export function isSubscribed (state, isSubscribed) {
	state.isSubscribed = isSubscribed;

	if (!isSubscribed) state.subscription = {};
}
